import React from 'react';
import Gallery from './Gallery';
import { useGalleryArgentiqueImages } from '../hooks/useGalleryArgentiqueImages';

const DynamicArgentiqueGallery: React.FC = () => {
  const { images, config, error } = useGalleryArgentiqueImages();

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '1.2rem',
        color: 'red'
      }}>
        Erreur: {error}
      </div>
    );
  }

  if (!config || images.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '1.2rem'
      }}>
        Aucune image trouvée pour cette galerie.
      </div>
    );
  }

  return (
    <Gallery
      images={images}
      title={config.title}
      imageSize={{ width: '300px', height: '300px' }}
      bgImage={config.bgImage}
    />
  );
};

export default DynamicArgentiqueGallery;